import victor from "../img/victorCut.png";

export function About() {
  return (
    <div className="about">
      <div>
        <div className="mb-3">
          <img className="victor" src={victor} alt="Victor Barcellos" />
          <p>
            I’m <strong>Victor Barcellos</strong>, a Brazilian <strong>full-stack
            developer</strong> passionate about designing intuitive user interfaces and
            building the backend systems that support them. I currently work as a{" "}
            <strong>Software Development Analyst at SimpleLab</strong>, crafting
            geotechnical software used in real engineering projects.
          </p>
        </div>

        <div className="mb-3">
          <p>
            On the front end I work mainly with <strong>React 18</strong>, using{" "}
            <strong>Redux Toolkit</strong> and <strong>React Router</strong> to manage
            state and navigation, along with modern CSS/SCSS for styling. On the back end
            I build APIs with <strong>Node.js</strong> and <strong>Express</strong>,
            usually backed by <strong>MongoDB</strong> with <strong>Mongoose</strong>.
            I’m also comfortable working in Docker and AWS environments. I put a lot of
            focus on keeping code maintainable, using semantic commits, and making sure
            features are covered by tests and CI checks.
          </p>
          <p>
            Highlights include a configurable SVG/UI for geotechnical instruments, 3D visualization
            of geological layers using <strong>CesiumJS</strong>, and robust
            data-entry flows with validations, transactions, and schema
            migrations. I also build portfolio projects like{" "}
            <strong>Gardrobe</strong> (an e-commerce demo on Vercel) to practice
            product thinking and UX details.
          </p>
        </div>

        <div className="mb-3">
          <h3 className="h5">Skills & Tools</h3>
          <ul>
            <li>
              <strong>Front-end:</strong> React 18, Redux Toolkit, React Router,
              JSX, CSS/SCSS, Bootstrap, accessibility, responsive UI.
            </li>
            <li>
              <strong>Back-end:</strong> Node.js, Express, REST APIs, Mongoose,
              MongoDB.
            </li>
            <li>
              <strong>3D & Data Viz:</strong> CesiumJS/Resium, SVG rendering,
              performance-minded UI for large datasets.
            </li>
            <li>
              <strong>Testing & Quality:</strong> Jest (unit/integration),
              semantic commits, code review, GitHub Actions CI.
            </li>
            <li>
              <strong>DevOps & Infra:</strong> Docker, AWS (ECS/Secrets),
              Vercel, environment variables, build/deploy pipelines.
            </li>
          </ul>
        </div>

        <div className="mb-3">
          <h3 className="h5">How I work</h3>
          <p>
            I like clear naming, small components, and pragmatic abstractions.
            I document behavior with tests and READMEs, keep state predictable,
            and favor simple solutions that scale. I’m comfortable collaborating
            across product, design, and engineering to ship features with
            confidence.
          </p>
        </div>

        <div className="mb-3">
          <h3 className="h5">Currently</h3>
          <p>
            Improving my portfolio, and
            learning new design patterns. Always open to
            discussing front-end architecture, testing strategies, and
            performance on real-world apps.
          </p>
        </div>
      </div>
    </div>
  );
}
